module.exports = {
  what_is_xID: 'xIDとは',
  feature: '特徴',
  how_to_use: '利用方法',
  corporate_services: '法人向けAPI',
  contact_us: 'お問い合わせ',
  get_started_now_btn: '今すぐ始める',
};
